import MuiTextField, { TextFieldProps } from '@material-ui/core/TextField';
import React from 'react';
import styled from 'styled-components';
import { TinkPaletteColors } from '../../providers/ThemeProvider/theme';
import { Chevron } from '../Icons/Chevron';
import { MarginProps, styledMargin } from '../Margins/margins';

export type StyledTextFieldProps = TextFieldProps & {
  bgColor?: TinkPaletteColors;
} & MarginProps;

export const StyledTextField = styled(({ bgColor, ...props }) => <MuiTextField {...props} />)`
  && {
    ${styledMargin}
    /* Material UI put a very high specificity on hiding placeholders */
    label[data-shrink='false'] + .MuiInputBase-formControl input::placeholder {
      opacity: 1 !important;
    }
    ${(props) =>
      props.bgColor &&
      `
      input,
      .MuiSelect-root {
        background: ${props.theme.palette[props.bgColor].main};
      }
    `}
  }
`;

const SelectChevron = styled(Chevron)`
  position: absolute;
  right: ${(props) => props.theme.sizes.xsmall};
  pointer-events: none;
`;

export const TextField: React.FC<StyledTextFieldProps> = ({
  variant = 'outlined',
  bgColor,
  ...props
}) => (
  <StyledTextField
    variant={variant}
    SelectProps={{
      // eslint-disable-next-line react/no-unstable-nested-components
      IconComponent: React.memo(() => <SelectChevron fontSize="normal" color="primary" />),
    }}
    bgColor={bgColor}
    {...props}
  />
);
